module.exports = __webpack_public_path__ + "fonts/SourceSerifPro-Regular.woff!static";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SourceSerifPro-Regular.woff
// module id = 47
// module chunks = 0